<script lang="ts">
	type StrapiImage = {
		data: {
			attributes: {
				url: string
			}
		}
	}

	export let url: string
	export let alternativeText: string
	export let width: number
	export let bannerImage: StrapiImage
	export let bannerImageMobile: StrapiImage
</script>

<div class="col-span-12 md:col-span-{width}">
	{#if url?.length}
		<a href={url}>
			{#if bannerImageMobile?.data?.attributes?.url}
				<img src={bannerImageMobile.data.attributes.url} alt={alternativeText} class="md:hidden" />
				<img src={bannerImage.data.attributes.url} alt={alternativeText} class="hidden md:block" />
			{:else}
				<img src={bannerImage.data.attributes.url} alt={alternativeText} />
			{/if}
		</a>
	{:else if bannerImageMobile?.data?.attributes?.url}
		<img src={bannerImageMobile.data.attributes.url} alt={alternativeText} class="md:hidden" />
		<img src={bannerImage.data.attributes.url} alt={alternativeText} class="hidden md:block" />
	{:else}
		<img src={bannerImage.data.attributes.url} alt={alternativeText} />
	{/if}
</div>
